'use client';

import { useEffect } from 'react';

import type { RouterLocale } from '~i18n/constants';
import { initializeContentfulPreview } from '~shared/api/contentful/preview';

export function LivePreview({ locale }: { locale: RouterLocale }) {
	useEffect(() => {
		initializeContentfulPreview(locale);
	}, [locale]);

	return null;
}
